import {
  Address,
  AssetKey,
  getChainKeyFromProtocol,
  getIsWrappedNative,
  MarketAssetMeta,
  ProtocolKeyService,
} from "@silo/types";
import { Effect } from "effect";
import { getViemMarketAssetMeta } from "./get-viem-market-asset-meta";
import { AssetInfo } from "./types";

export type GetMarketAssetMeta = ReturnType<typeof getMarketAssetMeta>;
export type GetMarketAssetMetaSuccess =
  Effect.Effect.Success<GetMarketAssetMeta>;
export type GetMarketAssetMetaError = Effect.Effect.Error<GetMarketAssetMeta>;
export type GetMarketAssetMetaContext =
  Effect.Effect.Context<GetMarketAssetMeta>;

interface GetMarketAssetMetaParams {
  marketAddress: Address;
  assetKey: AssetKey;
  assetInfo: AssetInfo;
}

export function getMarketAssetMeta(params: GetMarketAssetMetaParams) {
  return Effect.gen(function* () {
    const protocolKey = yield* ProtocolKeyService;
    const { marketAddress, assetKey } = params;

    const {
      tokenAddress,
      rawSymbol,
      rawName,
      decimals,
      priceProvider,
      collateralShareToken,
      protectedShareToken,
      debtShareToken,
      maxLtv,
      lt,
    } = yield* getViemMarketAssetMeta(params);

    const chainKey = getChainKeyFromProtocol(protocolKey);
    const isNative = getIsWrappedNative(chainKey)(tokenAddress);

    const marketAssetMeta: MarketAssetMeta = {
      marketAddress,
      protocolKey,
      chainKey,
      assetKey,

      tokenAddress,
      rawSymbol,
      rawName,
      decimals,
      isNative,

      priceProvider,
      collateralShareToken,
      protectedShareToken,
      debtShareToken,
      maxLtv,
      lt,
    };

    return marketAssetMeta;
  });
}
